import {
  HttpContextToken,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, tap } from 'rxjs';
import { Logger } from '../services/logger/logger.service';

const MAX_CACHE_TIME_IN_SECONDS = 60 * 30;

export const IS_CACHE_ENABLED = new HttpContextToken<boolean>(() => false);
export const CACHE_KEY = new HttpContextToken<string>(() => '');

@Injectable()
export class HttpCacheInterceptor implements HttpInterceptor {
  private cache = new Map<string, { cachedAt: number; response: HttpResponse<any> }>();

  constructor(private logger: Logger) {}

  intercept<T>(request: HttpRequest<T>, next: HttpHandler) {
    if (request.method !== 'GET' || !(request.context.get(IS_CACHE_ENABLED) === true)) {
      return next.handle(request);
    }

    let cacheKey = request.context.get(CACHE_KEY);

    if (!cacheKey) {
      cacheKey = request.urlWithParams;
    }

    const cached = this.cache.get(cacheKey);
    if (cached && Date.now() - cached.cachedAt < MAX_CACHE_TIME_IN_SECONDS * 1000) {
      this.logger.trace('response from cache: ', request.url, { cacheKey });
      return of(cached.response.clone());
    }

    if (cached) {
      this.logger.trace('clearing from cache: ', request.url, { cacheKey });
      this.cache.delete(cacheKey);
    }

    return next.handle(request).pipe(
      tap((stateEvent) => {
        if (stateEvent instanceof HttpResponse && stateEvent.ok) {
          this.logger.trace('caching response: ', request.url, { cacheKey });
          this.cache.set(cacheKey, { response: stateEvent.clone(), cachedAt: Date.now() });
        }
      })
    );
  }
}
